import { useEffect, useRef, useState } from 'react';

export function useDebouncedValue<T>(value: T, delay = 400, skipInitial = true) {
  const [debounced, setDebounced] = useState(value);
  const firstRun = useRef(true);

  useEffect(() => {
    if (skipInitial && firstRun.current) {
      firstRun.current = false;
      return;
    }

    const handler = setTimeout(() => setDebounced(value), delay);

    return () => clearTimeout(handler);
  }, [value, delay, skipInitial]);

  return debounced;
}
